import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Communication = lazy(() => import('@feature/communication').then(m => ({ default: m.Communication })));
const Phenomenon = lazy(() => import('@feature/communication').then(m => ({ default: m.Phenomenon })));
const ListAlerts = lazy(() => import('@feature/alerts').then(m => ({ default: m.ListAlerts })));
const CreateForecast = lazy(() => import('@feature/createForecast').then(m => ({ default: m.CreateForecast })));
const CreateMultipleForecast = lazy(() => import('@feature/createMultipleForecast').then(m => ({ default: m.CreateMultipleForecast })));
const CreatePhenomenon = lazy(() => import('@feature/createPhenomenon').then(m => ({ default: m.CreatePhenomenon })));
const CreateDrill = lazy(() => import('@feature/createDrill').then(m => ({ default: m.CreateDrill })));
const AlertDetails = lazy(() => import('@feature/alertDetails').then(m => ({ default: m.AlertDetails })));

import { ROUTES } from '@shared/constants/routes.constants';

export const communicationRoutes: RouteObject[] = [
  {
    path: ROUTES.COMMUNICATION.ROOT,
    element: <Communication />,
  },
  {
    path: ROUTES.COMMUNICATION.LIST_ALERTS_PHENOMENON,
    element: <ListAlerts type="storm,flood,temp_flood,wind,drill,frost,tropical_cyclone,forest_fire,volcanic,low_temperatures,earthquake,tsunami,high_temperatures,environmental_risk,hail,dust_devil" />,
  },
  {
    path: ROUTES.COMMUNICATION.LIST_ALERTS_PHENOMENON_BY_TYPE,
    element: <ListAlerts />,
  },
  {
    path: ROUTES.COMMUNICATION.LIST_ALERTS_INFO,
    element: <ListAlerts type="info,traffic,security" />,
  },
  {
    path: ROUTES.COMMUNICATION.LIST_ALERTS_INFO_BY_TYPE,
    element: <ListAlerts />,
  },
  {
    path: ROUTES.COMMUNICATION.LIST_ALERTS_PRONOSTICS,
    element: <ListAlerts type="forecast" />,
  },
  {
    path: ROUTES.COMMUNICATION.LIST_ALERTS_PRONOSTICS_BY_TYPE,
    element: <ListAlerts />,
  },
  {
    path: ROUTES.COMMUNICATION.LIST_ALERTS_NEWS,
    element: <ListAlerts type="news" />,
  },
  {
    path: ROUTES.COMMUNICATION.LIST_ALERTS_NEWS_BY_TYPE,
    element: <ListAlerts />,
  },
  {
    path: ROUTES.COMMUNICATION.CREATE_FORECAST,
    element: <CreateForecast />,
  },
  {
    path: ROUTES.COMMUNICATION.CREATE_MULTIPLE_FORECAST,
    element: <CreateMultipleForecast />,
  },
  {
    path: ROUTES.COMMUNICATION.INFO,
    element: <Phenomenon type="info" />,
  },
  {
    path: ROUTES.COMMUNICATION.INFO_TYPES.GENERAL,
    element: <CreatePhenomenon type="info" />,
  },
  {
    path: ROUTES.COMMUNICATION.INFO_TYPES.TRAFFIC,
    element: <CreatePhenomenon type="traffic" />,
  },
  {
    path: ROUTES.COMMUNICATION.INFO_TYPES.SECURITY,
    element: <CreatePhenomenon type="security" />,
  },
  {
    path: ROUTES.COMMUNICATION.NEWS,
    element: <CreatePhenomenon type="news" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON,
    element: <Phenomenon />,
  },

  // Rutas de fenómenos
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.FLOOD,
    element: <CreatePhenomenon type="temp_flood" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.STORM,
    element: <CreatePhenomenon type="storm" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.HAIL,
    element: <CreatePhenomenon type="hail" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.WIND,
    element: <CreatePhenomenon type="wind" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.DRILL,
    element: <CreateDrill />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.FROST,
    element: <CreatePhenomenon type="frost" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.TROPICAL_CYCLONE,
    element: <CreatePhenomenon type="tropical_cyclone" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.FOREST_FIRE,
    element: <CreatePhenomenon type="forest_fire" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.DUST_DEVIL,
    element: <CreatePhenomenon type="dust_devil" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.VOLCANIC,
    element: <CreatePhenomenon type="volcanic" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.LOW_TEMPERATURES,
    element: <CreatePhenomenon type="low_temperatures" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.HIGH_TEMPERATURES,
    element: <CreatePhenomenon type="high_temperatures" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.EARTHQUAKE,
    element: <CreatePhenomenon type="earthquake" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.TSUNAMI,
    element: <CreatePhenomenon type="tsunami" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.ENVIRONMENTAL_RISK,
    element: <CreatePhenomenon type="environmental_risk" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.SILENT,
    element: <CreatePhenomenon type="silent" />,
  },
  // Rutas de detalles de alertas
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.PHENOMENON,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.INFO,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.PRONOSTICS,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.NEWS,
    element: <AlertDetails />,
  },
];
